var _a;
// this file is a copy of the v3 one, both need to be always in sync
// https://github.com/cloudscape-design/components/blob/main/src/internal/plugins/api.ts
import { DrawersController } from './controllers/drawers';
import { ActionButtonsController } from './controllers/action-buttons';
var storageKey = Symbol.for('awsui-plugin-api');
function findUpApi(currentWindow) {
    var _a;
    try {
        if ((_a = currentWindow) === null || _a === void 0 ? void 0 : _a[storageKey]) {
            return currentWindow[storageKey];
        }
        if (!currentWindow || currentWindow.parent === currentWindow) {
            // When the window has no more parents, it references itself
            return undefined;
        }
        return findUpApi(currentWindow.parent);
    }
    catch (ex) {
        // Most likely a cross-origin access error
        return undefined;
    }
}
function loadApi() {
    if (typeof window === 'undefined') {
        return createApi();
    }
    var win = window;
    var api = findUpApi(win);
    if (api) {
        return api;
    }
    win[storageKey] = createApi();
    return win[storageKey];
}
export var awsuiPlugins = (_a = loadApi(), _a.awsuiPlugins), awsuiPluginsInternal = _a.awsuiPluginsInternal;
function createApi() {
    var appLayoutDrawers = new DrawersController();
    var alertActions = new ActionButtonsController();
    var flashbarActions = new ActionButtonsController();
    return {
        awsuiPlugins: {
            appLayout: {
                registerDrawer: appLayoutDrawers.registerDrawer
            },
            alert: {
                registerAction: alertActions.registerAction
            },
            flashbar: {
                registerAction: flashbarActions.registerAction
            }
        },
        awsuiPluginsInternal: {
            appLayout: {
                clearRegisteredDrawers: appLayoutDrawers.clearRegisteredDrawers,
                onDrawersRegistered: appLayoutDrawers.onDrawersRegistered
            },
            alert: {
                clearRegisteredActions: alertActions.clearRegisteredActions,
                onActionRegistered: alertActions.onActionRegistered
            },
            flashbar: {
                clearRegisteredActions: flashbarActions.clearRegisteredActions,
                onActionRegistered: flashbarActions.onActionRegistered
            }
        }
    };
}
//# sourceMappingURL=api.js.map